import styles from "./check-item.module.css";
export const CheckItem = ({ text }) => {
  return (
    <div className={styles["check-item"]}>
      <img src="/assets/images/icons/checkbox.svg" alt="" />
      <span>{text}</span>
    </div>
  );
};
